<div class="loader">
    <ng-icon name="featherLoader"></ng-icon>
</div>